import apis from '@apis/index';
import ROUTER from '@constants/router';
import { setRestaurant } from '@stores/restaurant';
import axios from 'axios';
import { IYogiyoStore } from 'interfaces/store';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { UrlObject } from 'url';

export const saveRestaurnt = (item: IYogiyoStore) => {
  apis.store.setCachingStore('' + item.id, item);
};

export default function useStore() {
  const dispatch = useDispatch();
  const router = useRouter();

  const moveRestaurant = async ({
    item,
    category,
    queryString,
  }: {
    item: IYogiyoStore;
    category?: string;
    queryString?: UrlObject['query'];
  }) => {
    dispatch(setRestaurant(item));

    const _category = category ?? item.categories[0].split(';')[0];

    const url = `${ROUTER.restaurants(_category || '전체')}/${item.id}`;
    await router.push({ pathname: url, query: queryString });
    // saveRestaurnt(item);
  };

  return { moveRestaurant };
}
